export default "__VITE_ASSET__CMHZoBy$__"